<template>
    <div class="quickStake">
        <button
            v-for="(quickStake, index) in quickStakes"
            v-bind:key="quickStake"
            type="button"
            class="button _secondary"
            v-bind:class="`JARVIS_BetTicket_Btn_Shortcut${index}`"
            v-on:click="emit('addStake', quickStake * multiplier)"
        >
            +{{ formatMoney(quickStake * multiplier) }}
        </button>
    </div>
</template>

<script setup lang="ts">
    import { computed } from 'vue';
    import { getStakeInputMultiplier } from '@/libraries/helpers/stakeInputHelper';
    import { useAccountStore } from '@/stores/accountStore';

    const props = withDefaults(defineProps<{
        currency?: string;
    }>(), {
        currency: '',
    });

    const emit = defineEmits<{
        addStake: [stake: number];
    }>();

    const { formatMoney } = useAccountStore();
    const quickStakes = [25, 50, 75, 100];
    const multiplier = computed(() => getStakeInputMultiplier(props.currency));
</script>

<style lang="scss" scoped>
@import "@/scss/components/quickStake";
</style>
